/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Company } from "./Company";
import {
  CompanyFromJSON,
  CompanyFromJSONTyped,
  CompanyToJSON,
  CompanyToJSONTyped,
} from "./Company";
import type { CompanyDocument } from "./CompanyDocument";
import {
  CompanyDocumentFromJSON,
  CompanyDocumentFromJSONTyped,
  CompanyDocumentToJSON,
  CompanyDocumentToJSONTyped,
} from "./CompanyDocument";
import type { CustomerSpecificPricingAgreement } from "./CustomerSpecificPricingAgreement";
import {
  CustomerSpecificPricingAgreementFromJSON,
  CustomerSpecificPricingAgreementFromJSONTyped,
  CustomerSpecificPricingAgreementToJSON,
  CustomerSpecificPricingAgreementToJSONTyped,
} from "./CustomerSpecificPricingAgreement";

/**
 *
 * @export
 * @interface GetCompanyDocumentResponse
 */
export interface GetCompanyDocumentResponse {
  /**
   *
   * @type {Company}
   * @memberof GetCompanyDocumentResponse
   */
  company: Company;
  /**
   *
   * @type {CompanyDocument}
   * @memberof GetCompanyDocumentResponse
   */
  document: CompanyDocument;
  /**
   *
   * @type {CustomerSpecificPricingAgreement}
   * @memberof GetCompanyDocumentResponse
   */
  agreement?: CustomerSpecificPricingAgreement | null;
}

/**
 * Check if a given object implements the GetCompanyDocumentResponse interface.
 */
export function instanceOfGetCompanyDocumentResponse(
  value: object,
): value is GetCompanyDocumentResponse {
  if (!("company" in value) || value["company"] === undefined) return false;
  if (!("document" in value) || value["document"] === undefined) return false;
  return true;
}

export function GetCompanyDocumentResponseFromJSON(
  json: any,
): GetCompanyDocumentResponse {
  return GetCompanyDocumentResponseFromJSONTyped(json, false);
}

export function GetCompanyDocumentResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GetCompanyDocumentResponse {
  if (json == null) {
    return json;
  }
  return {
    company: CompanyFromJSON(json["company"]),
    document: CompanyDocumentFromJSON(json["document"]),
    agreement:
      json["agreement"] == null
        ? undefined
        : CustomerSpecificPricingAgreementFromJSON(json["agreement"]),
  };
}

export function GetCompanyDocumentResponseToJSON(
  json: any,
): GetCompanyDocumentResponse {
  return GetCompanyDocumentResponseToJSONTyped(json, false);
}

export function GetCompanyDocumentResponseToJSONTyped(
  value?: GetCompanyDocumentResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    company: CompanyToJSON(value["company"]),
    document: CompanyDocumentToJSON(value["document"]),
    agreement: CustomerSpecificPricingAgreementToJSON(value["agreement"]),
  };
}
